import React from "react";
import { Switch, Route } from "react-router-dom";
import { DashboardProvider } from "../../contexts/dashboard-context/DashboardContext";
import ManagementDashboard from "./index";
import ManagementDashboardDetails from "./ManagementDashboardDetails/managementDashboardDetails";
import {
  MANAGEMENT_DASHBOARD_BASE,
  MANAGEMENT_DASHBOARD_PATHS,
} from "./ManagementDashboardDetails/managementDashboardDetailsConfig";

/** Single provider so main dashboard and details share the same dashboard fetch/state. */
const ManagementDashboardRoutes: React.FC = () => (
  <DashboardProvider>
    <Switch>
      <Route
        exact
        path={MANAGEMENT_DASHBOARD_PATHS.federationDetails}
        component={ManagementDashboardDetails}
      />
      <Route
        exact
        path={MANAGEMENT_DASHBOARD_PATHS.organizationDetails}
        component={ManagementDashboardDetails}
      />
      <Route
        exact
        path={MANAGEMENT_DASHBOARD_PATHS.adserverDetails}
        component={ManagementDashboardDetails}
      />
      <Route exact path={MANAGEMENT_DASHBOARD_BASE} component={ManagementDashboard} />
    </Switch>
  </DashboardProvider>
);

export default ManagementDashboardRoutes;
